import { useCallback, useEffect } from 'react';
import { useAdvertsStore } from '../stores/adverts.store';

interface UseAdvertsListOptions { loadOnMount?: boolean; }

export const useAdvertsList = (options: UseAdvertsListOptions = {}) => {
  const { loadOnMount = true } = options;
  const { list, items, page, perPage, total, isLoading, isFetchingMore, searchQuery, remove } = useAdvertsStore();

  useEffect(() => { if (loadOnMount) { list(1, perPage); } }, [loadOnMount, list, perPage]);

  const search = useCallback(async (q: string) => {
    await list(1, perPage, q);
  }, [list, perPage]);

  const fetchNextPage = useCallback(async () => {
    if (isLoading || isFetchingMore) return;
    if (items.length >= total) return;
    await list(page + 1, perPage, searchQuery);
  }, [isLoading, isFetchingMore, items.length, total, list, page, perPage, searchQuery]);

  const removeAdvert = useCallback(async (uuid: string) => { await remove(uuid); }, [remove]);

  return {
    adverts: { items, page, perPage, total, hasNextPage: () => items.length < total, count: items.length },
    loading: isLoading || isFetchingMore,
    initialLoading: isLoading && items.length === 0,
    loadingMore: isFetchingMore,
    search,
    fetchNextPageAdverts: fetchNextPage,
    removeAdvert,
  };
};